import React from "react";
import { LegacyCard, InlineGrid, TextField, Select } from "@shopify/polaris";
import CustomAutocomplete from "../CustomAutocomplete";
import { SatinNumbers } from "../CoatData";
import { useLibrary } from "../LibraryContext";

const WomenVestForm = ({
  form,
  setForm,
  errors,
  conditionalFieldsMap,
}) => {
  const { fabrics: Fabrics, linings: LiningNumbers } = useLibrary();
  const handleChange =
    (section, key = null) =>
      (values) => {
        const trimmedKey = key?.trim();
        let value;
        if (Array.isArray(values)) {
          value = values[0];
        } else {
          value = values;
        }

        const sectionMap = conditionalFieldsMap[section];
        const fieldRule = sectionMap?.[trimmedKey];

        if (fieldRule) {
          const { conditionValue, dependentKey } = fieldRule;
          if (value === conditionValue) {
            // Add the dependent field
            setForm((prev) => ({
              ...prev,
              [section]: {
                ...prev[section],
                [trimmedKey]: value,
                [dependentKey]: "",
              },
            }));
          } else {
            // Remove the dependent field
            const updatedSection = { ...form[section] };
            delete updatedSection[dependentKey];
            updatedSection[trimmedKey] = value;

            setForm((prev) => ({
              ...prev,
              [section]: updatedSection,
            }));
          }

          return;
        }
        // Default update
        if (trimmedKey) {
          setForm((prev) => ({
            ...prev,
            [section]: {
              ...prev[section],
              [trimmedKey]: value,
            },
          }));
        } else {
          setForm((prev) => ({
            ...prev,
            [section]: value,
          }));
        }
      };

  const WomenvestFields = [
    {
      label: "Front Button",
      key: "frontButton",
      type: "select",
      options: [
        "5 Button",
        "3 Button",
        "4 Button",
        "DB 4 with 2 buttoned",
        "DB 6 with 2 buttoned",
        "DB 6 with 3 buttoned",
        "DB 8 with 4 buttoned",
      ],
    },
    {
      label: "Bottom",
      key: "bottom",
      type: "select",
      options: ["Regular Point", "Square", "Rounded", "Slant"],
    },
    {
      label: "Collar",
      key: "collar",
      type: "select",
      options: [
        "V Shape",
        "U Shape",
        "Notch Lapel",
        "Peak Lapel",
        "Shawl",
        "Notch Lapel with Collar",
        "Peak Lapel with Collar",
        "Shawl with Collar",
      ],
    },
    {
      label: "Lapel Contrast",
      key: "lapelContrast",
      type: "select",
      options: ["No", "Lapel", "Lapel edge"],
    },
    {
      label: "Lower Pocket",
      key: "lowerPocket",
      type: "select",
      options: ["Welt", "Slanted Welt", "Besom", "Slanted Besom", "Patch"],
    },
    {
      label: "Ticket Pocket",
      key: "ticketPocket",
      type: "select",
      options: ["No", "Yes"],
    },
    {
      label: "Back Fabric",
      key: "backFabric",
      type: "select",
      options: [
        "Fabric",
        "Lining Match Inside Lining",
        "Lining Match Fabric",
        "Lining Specify",
      ],
    },
    { label: "Inside Lining ", type: "select", key: "insideLining" },
    {
      label: "Tuxedo Wrap",
      key: "tuxedoWrap",
      type: "select",
      options: ["No", "Yes"],
    },
    {
      label: "Covered Button",
      key: "coveredButton",
      type: "select",
      options: ["No", "Match Fabric", "Satin Number"],
    },
  ];

  const renderSection = (title, fields, sectionKey) => (
    <LegacyCard title={title} sectioned>
      <InlineGrid columns={{ xs: 1, sm: 1, md: 2, lg: 3 }} gap="300">
        {fields.map(({ label, key, type = "text", options = [] }) => {
          if (type === "select") {
            return (
              <React.Fragment key={key}>
                {key !== "insideLining" && (
                  <div className="two_culumn">
                    <Select
                      label={label}
                      options={options}
                      value={form[sectionKey]?.[key] || ""}
                      onChange={handleChange(sectionKey, key)}
                      error={errors[sectionKey]?.[key]}
                    />
                    {key === "backFabric" &&
                      form[sectionKey]?.[key] === "Lining Specify" && (
                        <CustomAutocomplete
                          label="Lining Number "
                          optionsList={LiningNumbers}
                          onChange={handleChange(sectionKey, "backFabricLining")}
                          defaultValue={
                            form[sectionKey]?.["backFabricLining"] || ""
                          }
                        />
                      )}
                    {key === "tuxedoWrap" &&
                      form[sectionKey]?.[key] === "Yes" && (
                        <CustomAutocomplete
                          label="Satin Number"
                          optionsList={SatinNumbers}
                          onChange={handleChange(sectionKey, "tuxedoWrapSatin")}
                          defaultValue={
                            form[sectionKey]?.["tuxedoWrapSatin"] || ""
                          }
                        />
                      )}
                    {key === "coveredButton" &&
                      form[sectionKey]?.[key] === "Satin Number" && (
                        <CustomAutocomplete
                          label="Satin Number"
                          optionsList={SatinNumbers}
                          onChange={handleChange(sectionKey, "coveredButtonSatin")}
                          defaultValue={
                            form[sectionKey]?.["coveredButtonSatin"] || ""
                          }
                        />
                      )}
                  </div>
                )}
                {key === "insideLining" && (
                  <CustomAutocomplete
                    label={label}
                    optionsList={LiningNumbers}
                    onChange={handleChange(sectionKey, key)}
                    defaultValue={form[sectionKey]?.[key] || ""}
                  />
                )}
              </React.Fragment>
            );
          }
          return (
            <TextField
              key={key}
              label={label}
              value={form[sectionKey]?.[key] || ""}
              onChange={handleChange(sectionKey, key)}
              error={errors[sectionKey]?.[key]}
            />
          );
        })}
      </InlineGrid>
    </LegacyCard>
  );

  return renderSection("Women Vest", WomenvestFields, "womenvest");
};

export default WomenVestForm;
